import { useState } from 'react';

import { useEffectOnce } from '@genially/ui/build/hooks/useEffectOnce';

import { ViewApiService } from '../../infrastructure/ViewApiService';

export const useGeniallyImageRenderUrl = (geniallyId: string) => {
  const [geniallyImageRenderUrl, setGeniallyImageRenderUrl] = useState<
    string | undefined
  >(undefined);

  useEffectOnce(() => {
    const fetchGeniallyImageRenderUrl = async () => {
      try {
        const url = await ViewApiService.getGeniallyImageRenderUrl(geniallyId);

        setGeniallyImageRenderUrl(url);
      } catch (e) {
        console.error(e);
      }
    };

    fetchGeniallyImageRenderUrl();
  });

  return geniallyImageRenderUrl;
};
